// extracted by mini-css-extract-plugin
export default {"assigneeCell":"SupplierContracts_assigneeCell__6uuNY","unassigned":"SupplierContracts_unassigned__AD4bI"};